import React from 'react'

const Loader = () => {
  return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",width:"100vw",height:"100vh"}}>
        <img width="70%" src="https://i.pinimg.com/originals/5a/65/ee/5a65ee278cd557143f05a4ba91abbfa8.gif" alt="loader" />
    </div>
  )
}

export default Loader